<div class="label-value-item">
  <span class="label-value-item__label">{{ label }}</span>
  <span class="label-value-item__value">{{ value | appEmptyValue }}</span>
</div>
